import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=b324ed08&scoped=true&"
import script from "./Screenshots.vue?vue&type=script&lang=js&"
export * from "./Screenshots.vue?vue&type=script&lang=js&"
import style0 from "./Screenshots.vue?vue&type=style&index=0&id=b324ed08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b324ed08",
  null
  
)

export default component.exports